import {
  Home,
  Chat,
  Stream,
  ProductsPage,
  RealtimeProduct,
  Poll,
  Tapumes,
  Medidas,
  TextoEIcons,
  ConfigsGerais,
} from "~components/Pages";
import {
  HomeIcon,
  ProductsIcon,
  StreamIcon,
  RealtimeProductsIcon,
  PollIcon,
  ChatIcon,
  TapumesIcon,
  MeasureIcon,
  TextoEIconsIcon,
  ConfigsGeraisIcon,
} from "~components/Icons/NavigationMenuIcons";

export enum ROLES {
  admin = "admin",
  chat = "chat",
  usuario = "usuario",
}

export const ROUTES = [
  {
    to: "/home",
    icon: <HomeIcon />,
    primary: "home",
    roles: ["admin", "usuario"],
    screen: "home",
    element: <Home />,
  },
  {
    to: "/tapumes",
    icon: <TapumesIcon />,
    primary: "tapumes",
    roles: ["admin", "usuario"],
    screen: "tapumes",
    element: <Tapumes />,
  },
  {
    to: "/produto",
    icon: <ProductsIcon />,
    primary: "produtos",
    roles: ["admin", "usuario"],
    screen: "produtos",
    element: <ProductsPage />,
  },
  {
    to: "/medidas",
    icon: <MeasureIcon />,
    primary: "medidas",
    roles: ["admin", "usuario"],
    screen: "medidas",
    element: <Medidas />,
  },
  {
    to: "/produto-da-vez",
    icon: <RealtimeProductsIcon />,
    primary: "produto da vez",
    roles: ["admin", "usuario"],
    screen: "produto-da-vez",
    element: <RealtimeProduct />,
  },
  {
    to: "/enquete",
    icon: <PollIcon />,
    primary: "enquete",
    roles: ["admin", "usuario"],
    screen: "enquete",
    element: <Poll />,
  },
  {
    to: "/stream",
    icon: <StreamIcon />,
    primary: "transmissão",
    roles: ["admin", "usuario"],
    screen: "stream",
    element: <Stream />,
  },
  {
    to: "/chat",
    icon: <ChatIcon />,
    primary: "chat",
    roles: ["admin", "usuario", "chat"],
    screen: "chat",
    element: <Chat />,
  },
  {
    to: "/texto-e-icones",
    icon: <TextoEIconsIcon />,
    primary: "texto e ícones",
    roles: ["admin", "usuario"],
    screen: "texto-e-icones",
    element: <TextoEIcons />,
  },
  {
    to: "/configs-gerais",
    icon: <ConfigsGeraisIcon />,
    primary: "configs gerais",
    roles: ["admin", "usuario"],
    screen: "configs-gerais",
    element: <ConfigsGerais />,
  },
];
